export default {
  BASE_URL: '#{URL_BASE}#',
  AUTHORITY_URL: '#{AUTHORITY_URL}#',
};



// WEBPACK FOOTER //
// ./src/api/config/config.ci.js